import DetectRTC from 'detectrtc';
import localIpUrl from 'local-ip-url';
import isEqual from 'lodash/isEqual';
import uniq from 'lodash/uniq';
import {
    isBlockedByFirewallConditions,
    webRTCFirewallDetectionStates,
} from './constants/live-airmeet';
import { USER_ROLE } from './constants/users';

export const getUserDataPath = ({ airmeetId, userId, username }) =>
    `${airmeetId}/userInfo/${userId}/${username
        .replace(/[^a-zA-Z\s ]/g, '')
        .replace(/\t+/g, ' ')}`;

const { ORGANIZER, HOST, SPEAKER, ATTENDEE, EXHIBITOR, COHOST } = USER_ROLE;

export const isOrganizer = (role = '') => role.toLowerCase() === ORGANIZER;
export const isHost = (role = '') => role.toLowerCase() === HOST;
export const isCoHost = (role = '') => role.toLowerCase() === COHOST;
export const isAttendee = (role = '') => role.toLowerCase() === ATTENDEE;
export const isSpeaker = (role = '') => role.toLowerCase() === SPEAKER;
export const isExhibitor = (role = '') => role.toLowerCase() === EXHIBITOR;

export const isRoleEqual = (role1, role2) =>
    role1.toLowerCase() === role2.toLowerCase();

export const includesRole = (roles, role = '') => {
    const roleToTest = role.toLowerCase();
    return !!roles.find((role) => role.toLowerCase() === roleToTest);
};

let lastSavedUserData = null;
export const updateUserInfo = ({
    airmeetId,
    userId,
    username,
    firebaseClient,
    hasBlockedWebRTCConnection,
}) => {
    let browserNotification = 'Granted';
    DetectRTC.load(function () {
        if ('Notification' in window) {
            browserNotification = Notification.permission;
        }

        let data = {
            device: DetectRTC.isMobileDevice ? 'Mobile' : 'Desktop',
            webcam: DetectRTC.isWebsiteHasWebcamPermissions,
            microphone: DetectRTC.isWebsiteHasMicrophonePermissions,
            id: userId,
            browserNotification: browserNotification,
            username: username,
            url: window.location.href,
            browserDetails: {
                name: DetectRTC.browser.name,
                version: DetectRTC.browser.version,
            },
            osDetails: {
                name: DetectRTC.osName,
                version: DetectRTC.osVersion,
            },
            ip: localIpUrl('public'),
            Time: {
                userEnteredTime: 0,
                userExitTime: 0,
            },
            isBlockedByFirewall: isBlockedByFirewallConditions.includes(
                hasBlockedWebRTCConnection
            )
                ? true
                : false,
            isConnectedViaProxy:
                window && window.airmeet
                    ? window.airmeet.connectViaProxy ||
                      window.airmeet.useAirmeetProxy
                    : false,
            proxyType:
                hasBlockedWebRTCConnection ===
                    webRTCFirewallDetectionStates.proxySuccess ||
                hasBlockedWebRTCConnection ===
                    `${webRTCFirewallDetectionStates.proxySuccess}${webRTCFirewallDetectionStates.customTURNSuffix}`
                    ? 'agora'
                    : hasBlockedWebRTCConnection ===
                          webRTCFirewallDetectionStates.airmeetProxySuccess ||
                      hasBlockedWebRTCConnection ===
                          `${webRTCFirewallDetectionStates.airmeetProxySuccess}${webRTCFirewallDetectionStates.customTURNSuffix}`
                    ? 'airmeet'
                    : 'none',
            isUsingCustomTURN: hasBlockedWebRTCConnection.includes(
                webRTCFirewallDetectionStates.customTURNSuffix
            )
                ? true
                : false,
        };

        if (false === isEqual(lastSavedUserData, data)) {
            lastSavedUserData = data;
            _updateUserInfo({
                airmeetId,
                userId,
                username,
                firebaseClient,
                hasBlockedWebRTCConnection,
                data,
            });
        }
    });
};

const _updateUserInfo = ({
    airmeetId,
    userId,
    username,
    firebaseClient,
    data,
}) => {
    const path = getUserDataPath({
        airmeetId,
        userId,
        username,
    });
    firebaseClient.setData(path, data);
};

export const getUserCurrentLanguage = (user) => {
    const userSetLang = user?.metadata?.lang;
    if (userSetLang?.is_user_set) {
        return userSetLang?.key;
    }
    return null;
};

export const getStageUserIds = (airmeetData) => {
    let userFilter = [];
    if (airmeetData) {
        if (airmeetData.sessions) {
            userFilter = airmeetData.sessions.reduce(
                (users, sess) => [
                    ...users,
                    ...sess.host_id,
                    ...sess.speaker_id,
                    ...sess.cohost_ids,
                    sess.cloud_user_id,
                    sess.recording_user_id,
                ],
                []
            );
        }

        // Adding airmeet host as part of user api call.
        if (airmeetData.host) {
            userFilter.push(airmeetData.host);
        }
    }
    return uniq(userFilter);
};
